import { Button, Image, Input, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";

const QUESTION_BASE_URL = "https://asquera.com/asquera";

const hasQuestionMedia = (value) =>
  Boolean(value) && value !== "null" && value !== "undefined";

const QuestionQuickUpdate = ({ data, isUpdating, onUpdate }) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    setFile(null);
    setFileName("");
  }, [data?.id, data?.model_answer_image]);

  return (
    <VStack
      align="stretch"
      spacing="8px"
      minW="230px"
      onClick={(e) => e.stopPropagation()}
    >
      {hasQuestionMedia(data?.model_answer_image) && (
        <Image
          src={`${QUESTION_BASE_URL}/${data.model_answer_image}`}
          alt="model answer"
          maxH="70px"
          objectFit="contain"
          borderRadius="6px"
        />
      )}
      <Button
        size="sm"
        bg="main_1"
        color="white"
        borderRadius="8px"
        position="relative"
        textAlign="center"
      >
        <Text fontSize="12px" noOfLines={1}>
          {fileName
            ? fileName
            : hasQuestionMedia(data?.model_answer_image)
              ? "تغيير صورة النموذج"
              : "صورة نموذج الإجابة"}
        </Text>
        <Input
          type="file"
          accept="image/*"
          opacity="0"
          position="absolute"
          w="100%"
          h="100%"
          cursor="pointer"
          onChange={(e) => {
            const nextFile = e.target.files?.[0];
            setFile(nextFile || null);
            setFileName(nextFile?.name || "");
          }}
        />
      </Button>
      <Button
        size="sm"
        bg="main_1"
        color="white"
        isLoading={isUpdating}
        onClick={() => onUpdate({ data, file })}
      >
        Update
      </Button>
    </VStack>
  );
};

export default QuestionQuickUpdate;
